import { Actions, type AllSubjects } from '@/rules/abilityTypes'
import { buildAbilityFor, can as checkPermission } from '@/appAbility'
import { useUserStore } from '@/stores/user'

export async function can(
  action: Actions,
  subject: AllSubjects,
  params?: Record<string, string | string[]>
): Promise<boolean> {
  const userStore = useUserStore()

  if (userStore.user?.userId == null || userStore.user.userId === '') {
    throw new Error('User ID is required for permission check')
  }

  const { ability, resolvers } = buildAbilityFor(userStore.role, userStore.user.userId)
  return await checkPermission(action, subject, params, resolvers, ability)
}
